import React from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import MobileLoginButton from "./MobileLoginButton"
import LoginButton from "./LoginButton"
import NavMenu from "./NavMenu"
import logo from "../../img/logo.png"

const Navbar = class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
      navBarActiveClass: "",
    }
  }

  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
              navBarActiveClass: "is-active",
            })
          : this.setState({
              navBarActiveClass: "",
            })
      }
    )
  }

  render() {
    return (
      <CustomNav
        className="navbar is-primary is-fixed-top"
        role="navigation"
        aria-label="main-navigation"
      >
        <div className="container">
          <div className="navbar-brand">
            <Link
              to="/"
              className="navbar-item"
              title="Looking for Sponsor Logo"
            >
              <img
                src={logo}
                alt="Looking For Sponsor"
                style={{ width: 150 }}
              />
            </Link>
            <div className="navbar-item is-hidden-desktop">
              <MobileLoginButton />
            </div>

            {/* Hamburger menu */}
            <button
              className={`button is-primary navbar-burger ${this.state.navBarActiveClass}`}
              data-target="navMenu"
              onClick={() => this.toggleHamburger()}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
          <div
            id="navMenu"
            className={`navbar-menu ${this.state.navBarActiveClass}`}
          >
            <div className="navbar-start has-text-centered">
              <NavMenu toggleHamburger={this.toggleHamburger} />
            </div>
          </div>

          <div className="navbar-end">
            <LoginButton />
          </div>
        </div>
      </CustomNav>
    )
  }
}

const CustomNav = styled.nav`
  a {
    text-decoration: none;
    font-weight: bold;
  }
`

export default Navbar
